import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { registrarSW } from "@/lib/push";

// rc135 — PWA: service worker (push + app shell). Si una notificación se toca
// con la app ya abierta, el SW manda {type:"navegar", url} y navegamos aquí.
registrarSW();
navigator.serviceWorker?.addEventListener("message", (e: MessageEvent) => {
  if (e.data?.type === "navegar" && typeof e.data.url === "string") {
    window.history.pushState({}, "", e.data.url);
    window.dispatchEvent(new PopStateEvent("popstate"));
  }
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
